import { render, staticRenderFns } from "./DialogScope.vue?vue&type=template&id=281c6b3f&scoped=true"
import script from "./DialogScope.vue?vue&type=script&lang=js"
export * from "./DialogScope.vue?vue&type=script&lang=js"
import style0 from "./DialogScope.vue?vue&type=style&index=0&id=281c6b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c6b3f",
  null
  
)

export default component.exports